import React from 'react';
import { Button } from '../primitives/Button';
import { assetUri } from '../utils/assetUri';
import heroSmall1xRaw from '../../../assets/images/landing-v2/responsive/hero/small.webp';
import heroSmall2xRaw from '../../../assets/images/landing-v2/responsive/hero/small-2x.webp';
import heroMedium1xRaw from '../../../assets/images/landing-v2/responsive/hero/medium.webp';

const heroSmall1x = assetUri(heroSmall1xRaw);
const heroSmall2x = assetUri(heroSmall2xRaw);
const heroMedium1x = assetUri(heroMedium1xRaw);
const heroMedium2x = heroSmall2x;

export default function Hero({ content, onCtaPress, ctaHref = '/onboarding' }) {
  const titleLine1 = content?.titleLine1 || 'The smartest way';
  const titleLine2 = content?.titleLine2 || 'to buy your next car';
  const subtitle = content?.subtitle || "We analyse every UK listing across every platform.\nAI matches them to exactly what you're looking for.";
  const ctaTitle = content?.cta?.title || 'Get Started';
  const reassurance = content?.reassurance || 'Free to start. No card needed.';

  return (
    <section
      id="top"
      className="relative w-full h-[100dvh] md:!h-auto md:aspect-[1.77/1] md:max-h-[100dvh] flex items-end overflow-hidden bg-surface-darker"
    >
      <picture className="absolute inset-0 z-0 overflow-hidden">
        <source
          media="(max-width: 767px)"
          srcSet={`${heroSmall1x} 1x, ${heroSmall2x} 2x`}
          type="image/webp"
        />
        <source
          media="(min-width: 768px)"
          srcSet={`${heroMedium1x} 1x, ${heroMedium2x} 2x`}
          type="image/webp"
        />
        {/* Figma exports the hero image as background:url(...) -13px -198.395px / 101.806% 124.125%
            on a 1440x812 frame - i.e. anchored to the bottom-left, oversized so it overflows the
            top (no centred cover). The percentages let it scale with the responsive frame. */}
        <img
          src={heroMedium1x}
          alt=""
          fetchPriority="high"
          decoding="async"
          className="absolute object-cover max-w-none -scale-x-100"
          style={{
            left: '-0.903%',
            top: '-24.43%',
            width: '101.806%',
            height: '124.125%',
          }}
        />
      </picture>
      <div className="lp-v2-hero-overlay absolute inset-0 z-10 pointer-events-none" />
      <div className="relative z-20 px-6 md:px-[120px] pb-20 w-full">
        <div className="w-full max-w-[1200px] mx-auto">
          <div className="flex flex-col gap-8 md:gap-12 items-start max-w-[890px]">
            <div className="flex flex-col gap-6 w-full">
              <h1 className="font-display font-bold text-4xl md:text-[64px] leading-[1.1] tracking-tight">
                <span className="lp-v2-gradient-text block">{titleLine1}</span>
                <span className="lp-v2-gradient-text block">{titleLine2}</span>
              </h1>
              <p className="font-sans font-normal text-lg md:text-2xl leading-[1.2] text-on-dark max-w-[60ch] whitespace-pre-line">
                {subtitle}
              </p>
            </div>
            <div className="flex items-center gap-4 flex-wrap">
              <Button variant="light" as="a" href={ctaHref} onClick={onCtaPress}>{ctaTitle}</Button>
              <span className="font-sans text-on-dark/70 text-sm">{reassurance}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
